module.exports = __webpack_public_path__ + "img/bird_2.49b2f8b4.png";